export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">
            联系我们
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
            如有任何问题、建议或合作意向，欢迎通过以下方式与99视频团队取得联系
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="bg-background-50 rounded-2xl p-8 border border-background-200/60">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 mb-8">
              <div className="text-center p-4 rounded-xl bg-background-100 hover:bg-primary-50/50 transition-colors cursor-pointer">
                <div className="w-11 h-11 rounded-xl bg-primary-50 flex items-center justify-center mx-auto mb-3">
                  <i className="ri-mail-line text-primary-500 text-lg"></i>
                </div>
                <p className="text-sm font-medium text-foreground-950 mb-1">邮件联系</p>
                <p className="text-xs text-foreground-500">contact@99video.com</p>
              </div>
              <div className="text-center p-4 rounded-xl bg-background-100 hover:bg-accent-50/50 transition-colors cursor-pointer">
                <div className="w-11 h-11 rounded-xl bg-accent-50 flex items-center justify-center mx-auto mb-3">
                  <i className="ri-wechat-line text-accent-500 text-lg"></i>
                </div>
                <p className="text-sm font-medium text-foreground-950 mb-1">微信客服</p>
                <p className="text-xs text-foreground-500">99video_official</p>
              </div>
              <div className="text-center p-4 rounded-xl bg-background-100 hover:bg-secondary-50/50 transition-colors cursor-pointer">
                <div className="w-11 h-11 rounded-xl bg-secondary-50 flex items-center justify-center mx-auto mb-3">
                  <i className="ri-send-plane-line text-secondary-500 text-lg"></i>
                </div>
                <p className="text-sm font-medium text-foreground-950 mb-1">内容投稿</p>
                <p className="text-xs text-foreground-500">submit@99video.com</p>
              </div>
            </div>

            <div className="text-center pt-5 border-t border-background-200/60">
              <p className="text-sm text-foreground-600 mb-1">
                工作时间：周一至周日 9:00 - 22:00
              </p>
              <p className="text-xs text-foreground-500">
                香蕉视频、红桃视频、91视频、蜜桃视频平台相关问题也可通过上述渠道反馈
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}